import React, { useState, useEffect } from 'react';
import { useApp } from '../../app/AppContext';
import {App, FilterByMode} from '../../app/AppSingleton';
import { AppSignals } from '../../app/AppSignals';
import './Board.filters.css';

interface BoardFiltersProps {
    // Компонент не принимает пропсов, работает через App состояние
}


const BoardFilters: React.FC<BoardFiltersProps> = () => {
	const app = App.getInstance();
	const [filters, setFilters] = useState(app.getFilters());
	const [showFilters, setShowFilters] = useState<boolean>(app.getState().showFilters);
	const [stats, setStats] = useState(app.getListStats());

	useEffect(() => {
		const unsubscribeBoard = AppSignals.boardUpdated.subscribe(() => {
			setFilters(app.getFilters());
			setShowFilters(app.getState().showFilters);
			setStats(app.getListStats());
		});

		const unsubscribeFilters = AppSignals.filtersToggled.subscribe((newShowFilters) => {
			setShowFilters(newShowFilters);
		});

		return () => {
			unsubscribeBoard();
			unsubscribeFilters();
		};
	}, [app]);

	const handleFilterChange = (status: FilterByMode): void => {
		app.setFilterStatus(status);
	};

	const filterSpecs :{id:FilterByMode, label:string, count:number}[] = [
		{ id: 'all' as const, label: 'Все', count: stats.total },
		{ id: 'unsynced' as const, label: 'Не синхр.', count: stats.unsynced },
		{ id: 'recent' as const, label: 'Сегодня', count: stats.recent },
	];

	return (
		<div className="board-filters">
			<div className="board-filters__container">
				{filterSpecs.map(spec => (
					<button
						key={spec.id}
						className={`board-filters__button ${
							filters.status === spec.id ? 'board-filters__button--active' : ''
						} ${spec.id}`}
						onClick={() => handleFilterChange(spec.id)}
					>
						{spec.label} ({spec.count})
					</button>
				))}
			</div>
		</div>
	);
};

export default BoardFilters;
